'use client';

import classNames from '@sindresorhus/class-names';
import {Logo as ILogo} from '@ui-kit/src/Header/Header.types';
import {headerTestId} from '@ui-kit/src/Header/headerTestid';
import Image from 'next/image';

import styles from './Logo.module.scss';

interface Props {
  logo: ILogo;
  topScroll: boolean;
  isMenuOpened: boolean;
  scaleLogo?: boolean;
}

export const Logo = ({
  logo: {logoHref, afterLogoImageHref, href},
  topScroll,
  isMenuOpened,
  scaleLogo,
}: Props) => {
  return (
    <a
      href={href}
      className={classNames(styles.logoWrapper, {
        [styles.scaleLogo]: scaleLogo && topScroll,
        [styles.showInMenu]: isMenuOpened,
      })}
      data-testid={headerTestId.logo}
    >
      <Image
        src={logoHref}
        className={styles.logo}
        alt="RuStore"
        width={143}
        height={36}
      />
      {afterLogoImageHref && (
        <Image
          src={afterLogoImageHref}
          className={styles.afterLogo}
          alt="additionalLogo"
          aria-hidden
          width={112}
          height={40}
        />
      )}
    </a>
  );
};
